import React, { useState, useEffect } from 'react';
import { MapPin, Calendar, Users, Clock, Info, X, ExternalLink, Search, Send, Plus, ArrowRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Logo from '../../components/Logo';
import Footer from '../../components/Footer';
import WalletMenu from '../../components/WalletMenu';
import { supabase } from '../../lib/supabase';
import NavigationMenu from '../../components/NavigationMenu';
import YachtDetailModal from '../../components/modals/YachtDetailModal';

// Definiere die Yacht-Schnittstelle direkt hier, falls sie nicht importiert wird
interface Yacht {
  id: number;
  name: string;
  type: string;
  length: string;
  capacity: string;
  crew: string;
  price: string;
  location: string;
  image: string;
}

export default function YachtCharter() {
  const { isAuthenticated, user } = useAuth();
  const [yachts, setYachts] = useState<Yacht[]>([
    {
      id: 1,
      name: 'Oceanic Majesty',
      type: 'Motor Yacht',
      length: '45m',
      capacity: '12 guests',
      crew: '9 crew',
      price: '€150,000/week',
      location: 'Mediterranean',
      image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80 '
    },
    {
      id: 2,
      name: 'Azure Voyager',
      type: 'Sailing Yacht',
      length: '38m',
      capacity: '8 guests',
      crew: '6 crew',
      price: 'on request',
      location: 'Caribbean',
      image: 'https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/sign/yachts/Azure-super-yacht-Purity-concept.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2MyODA1ZWVkLWRiNGMtNGQ1NC1iNzI4LWJmNDIxMDkzNGVjYiJ9.eyJ1cmwiOiJ5YWNodHMvQXp1cmUtc3VwZXIteWFjaHQtUHVyaXR5LWNvbmNlcHQuanBnIiwiaWF0IjoxNzQ3MTI5MTk3LCJleHAiOjI0NDkyODkxODQ5NDY3OTd9.Xb6ajCrHRRd_NW3vTD4eq0sc2dRHKKUyB7krxse1lvY '
    },
    {
      id: 3,
      name: 'Sovereign Seas',
      type: 'Super Yacht',
      length: '65m',
      capacity: '16 guests',
      crew: '18 crew',
      price: '€350,000/week',
      location: 'Mediterranean',
      image: 'https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/sign/yachts/2003-sovereign-tri-deck-power-9675795-20250408083647096-1_LARGE.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2MyODA1ZWVkLWRiNGMtNGQ1NC1iNzI4LWJmNDIxMDkzNGVjYiJ9.eyJ1cmwiOiJ5YWNodHMvMjAwMy1zb3ZlcmVpZ24tdHJpLWRlY2stcG93ZXItOTY3NTc5NS0yMDI1MDQwODA4MzY0NzA5Ni0xX0xBUkdFLmpwZyIsImlhdCI6MTc0NzEyOTEzMiwiZXhwIjoxMzIxMzYyMTc5Njg5MTMyfQ.avP77cWkoATt9yXjWzn4L0PKZSy6zi0OU14c-B_MJj0 '
    },
    {
      id: 4,
      name: 'Celestial Wave',
      type: 'Motor Yacht',
      length: '50m',
      capacity: '12 guests',
      crew: '10 crew',
      price: '€180,000/week',
      location: 'South Pacific',
      image: 'https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/sign/webappimages/TiKAFpUxRQ2etVsZl0IZ_Riva-110-Dolcevita.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2MyODA1ZWVkLWRiNGMtNGQ1NC1iNzI4LWJmNDIxMDkzNGVjYiJ9.eyJ1cmwiOiJ3ZWJhcHBpbWFnZXMvVGlLQUZwVXhSUTJldFZzWmwwSVpfUml2YS0xMTAtRG9sY2V2aXRhLmpwZyIsImlhdCI6MTc0NjUyMjM1OCwiZXhwIjoxNDcwNjUyMjM1OH0.aHC-vRFZYqB0j8WQd8RELkSg_1IHZT-iKUV4xl7jGl8 '
    },
    {
      id: 5,
      name: 'Silver Dream',
      type: 'Motor Yacht',
      length: '32m',
      capacity: '12 guests',
      crew: '6 crew',
      price: '€75,000/week',
      location: 'on request',
      image: 'https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/sign/yachts/y_49_full.avif?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2MyODA1ZWVkLWRiNGMtNGQ1NC1iNzI4LWJmNDIxMDkzNGVjYiJ9.eyJ1cmwiOiJ5YWNodHMveV80OV9mdWxsLmF2aWYiLCJpYXQiOjE3NDcxMjkyODksImV4cCI6MTc3ODY2NTI4OX0.pXz4LNp23cDkSykOCyLMXEAzkZoRC8J7BrwVbLva0Hc '
    },
    {
      id: 6,
      name: 'Flying Fox',
      type: 'Super Yacht',
      length: '136m',
      capacity: '18 guests',
      crew: '22 crew',
      price: '€3,500,000.00/week',
      location: 'Caribbean',
      image: 'https://sgfnbormqiqgvhdfwmhz.supabase.co/storage/v1/object/sign/yachts/flyingFox.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2MyODA1ZWVkLWRiNGMtNGQ1NC1iNzI4LWJmNDIxMDkzNGVjYiJ9.eyJ1cmwiOiJ5YWNodHMvZmx5aW5nRm94LmpwZyIsImlhdCI6MTc0NzEyOTY1NiwiZXhwIjoxMzIwNTMzOTk2NTgzNTgwODAwMDB9.fZiBLTpWcmXtJJo3kBEJlyRFDBvKnidHUE24jtM_Wxk '
    }
  ]);

  const [loading, setLoading] = useState(false);
  const [selectedYacht, setSelectedYacht] = useState<Yacht | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkAdminStatus();
    // In a real application, you would fetch yachts from Supabase here
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [user]);

  const checkAdminStatus = async () => {
    if (!user) return;
    try {
      const { data: userData, error } = await supabase
        .from('users')
        .select('is_admin')
        .eq('id', user.id)
        .single();
      if (!error && userData) {
        setIsAdmin(userData.is_admin);
      }
    } catch (error) {
      console.error('Error checking admin status:', error);
    }
  };

  const handleYachtClick = (yacht: Yacht) => {
    setSelectedYacht(yacht);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedYacht(null);
  };

  const filteredYachts = yachts.filter(yacht => {
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      return (
        yacht.name.toLowerCase().includes(search) ||
        yacht.type.toLowerCase().includes(search) ||
        yacht.location.toLowerCase().includes(search)
      );
    }
    if (filterType !== 'all') {
      return yacht.type.toLowerCase().includes(filterType.toLowerCase());
    }
    return true;
  });

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-gray-50 to-white border-b border-gray-100">
        <div className="max-w-8xl mx-auto">
          <div className="flex items-center justify-between py-4 px-6">
            <div className="flex items-center gap-8">
              <Logo />
              <NavigationMenu />
            </div>
            <div className="flex items-center gap-4">
              <WalletMenu onShowDashboard={() => {}} />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 pt-[88px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Hero Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Yacht Charter</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Experience the ultimate in luxury at sea with our premium yacht charter services. Explore the world's most beautiful destinations in unparalleled style and comfort.
            </p>
          </div>

          {/* Search Bar */}
          <div className="mb-8">
            <div className="max-w-md mx-auto">
              <div className="relative">
                <Search size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search by name, type, or location..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent shadow-sm"
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm('')}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <X size={16} />
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Admin Add Button */}
          {isAdmin && (
            <div className="mb-6 flex justify-end">
              <a 
                href="/admin/yachts" 
                className="inline-flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
              >
                <Plus size={18} />
                <span>Add New Yacht</span>
              </a>
            </div>
          )}

          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            <button
              onClick={() => setFilterType('all')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filterType === 'all' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              All Yachts
            </button>
            <button
              onClick={() => setFilterType('motor')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filterType === 'motor' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Motor Yachts
            </button>
            <button
              onClick={() => setFilterType('sailing')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filterType === 'sailing' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Sailing Yachts
            </button>
            <button
              onClick={() => setFilterType('super')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filterType === 'super' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Super Yachts
            </button>
          </div>

          {/* Yachts Grid */}
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <div className="w-12 h-12 border-4 border-gray-200 border-t-black rounded-full animate-spin"></div>
            </div>
          ) : filteredYachts.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredYachts.map((yacht) => (
                <div 
                  key={yacht.id} 
                  className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow border border-gray-100 cursor-pointer group"
                  onClick={() => handleYachtClick(yacht)}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={yacht.image} 
                      alt={yacht.name} 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-3 left-3 bg-blue-500 text-white text-xs px-3 py-1 rounded-full">
                      {yacht.type}
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-lg font-bold mb-2">{yacht.name}</h3>
                    <div className="flex items-center text-gray-600 mb-3">
                      <MapPin size={16} className="mr-1" />
                      <span className="text-sm">{yacht.location}</span>
                    </div>
                    <div className="flex flex-wrap gap-3 mb-4">
                      <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full">
                        <Users size={14} className="mr-1" />
                        <span>{yacht.capacity}</span>
                      </div>
                      <div className="flex items-center text-xs bg-gray-100 px-2 py-1 rounded-full">
                        <Clock size={14} className="mr-1" />
                        <span>{yacht.length}</span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-lg font-bold">
                        {yacht.price}
                      </div>
                      <button className="text-xs bg-black text-white px-3 py-1.5 rounded-lg font-medium hover:bg-gray-800 transition-colors">
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Info size={24} className="text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">No yachts found</h3>
              <p className="text-gray-500 mt-2">
                No yachts match your search criteria. Please try different search terms or filters.
              </p>
            </div>
          )}

          {/* CTA Section */}
          <div className="bg-black text-white p-12 rounded-2xl text-center mt-16">
            <h2 className="text-3xl font-bold mb-4">Ready to Set Sail?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Book your luxury yacht charter today and experience the ultimate in maritime luxury. More highly exclusive yachts available upon request.
            </p>
            <a 
              href="#"
              className="inline-flex items-center gap-2 bg-white text-black px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              Contact Us <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </main>
      <Footer />

      {/* Yacht Detail Modal */}
      {showModal && selectedYacht && (
        <YachtDetailModal yacht={selectedYacht} onClose={closeModal} />
      )}
    </div>
  );
}